export enum TILE_DESIGNS {
    SQUARED = 'squared',
    RECTANGLE = 'rectangle'
}